import $ from 'jquery';

class ChangeNav {
    constructor() {
        this.nav = $("#white-header");
        this.logo = $("#nav-logo");
        this.spare = $("#spare");
        this.window = $(window);

        if(this.nav) {
            this.events();
        }
    }

    // events
    events() {
        this.checkScroll.bind(this);
        this.window.on('scroll', this.checkScroll.bind(this));
    }

    // methods
    checkScroll(e) {
        if (this.window.scrollTop() === 0) {
            this.spare.addClass('hide');
            this.logo.removeClass('hide');
            this.nav.addClass('wht-nav');
        } else {
            this.logo.addClass('hide');
            this.spare.removeClass('hide')
            this.nav.removeClass('wht-nav');
        }
    }
}

export default ChangeNav;